import React, { useContext, useEffect } from "react";
import UserContext from "../components/UserContext";
import fetchLatestLendOffers from "../services/fetchLatestLendOffers";
import fetchLends from "../services/fetchLends";
import fetchTopLendOffers from "../services/fetchTopLendOffers";
import Home_1 from "./home/home_1";

export default function Home(props: { latestOffers; topOffers; lastListed }) {
  const { scrollRef } = useContext(UserContext);

  useEffect(() => {
    window.scrollTo(0, scrollRef.current.scrollPos);
    const handleScrollPos = () => {
      scrollRef.current.scrollPos = window.scrollY;
    };
    window.addEventListener("scroll", handleScrollPos);
    return () => {
      window.removeEventListener("scroll", handleScrollPos);
    };
  });

  return <Home_1 {...props} />;
}

export async function getServerSideProps() {
  try {
    const [
      { results: latestOffers },
      { results: topOffers },
      { results: lastListed },
    ] = await Promise.all([
      fetchLatestLendOffers({}),
      fetchTopLendOffers({}),
      fetchLends({ sort: "createdAt:desc", listed: true, cached: true }),
    ]);
    return {
      props: {
        latestOffers,
        topOffers,
        lastListed,
      },
    };
  } catch (error) {
    console.error("index.tsx getServerSideProps error", error);
    return {
      props: {
        latestOffers: [],
        topOffers: [],
        lastListed: [],
      },
    };
  }
}

// const newrelicDeps = [
//   "@newrelic/next",
//   "newrelic",
//   "semver",
//   "json-stringify-safe",
//   "readable-stream",
//   "inherits",
//   "util-deprecate",
//   "lru-cache",
//   "yallist",
//   "async",
//   "concat-stream",
//   "buffer-from",
//   "https-proxy-agent",
//   "debug",
//   "ms",
//   "agent-base",
//   "@tyriar/fibonacci-heap",
// ];

// export const config = {
//   unstable_includeFiles: newrelicDeps.map(
//     (d) => `node_modules/${d}/**/*.+(js|json)`
//   ),
// };
